<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 7/30/20
-->

<template>
	<div class="w-100 mt-3 mb-5 relative">
		<!--		v-if="clientList.length">-->
		<!--		<div class="row w-100 mx-0 mb-5 px-3">-->

		<!--			<BackHeader title="Coaching clients" :hideBack="true"/>-->
		<!--			<div class="layout-spacer"/>-->
		<!--			<div>-->
		<!--				<qw-button type="primary"-->
		<!--						   size="small"-->
		<!--						   @click="onAddClientClicked">-->
		<!--					+ Add client-->
		<!--				</qw-button>-->
		<!--			</div>-->
		<!--		</div>-->

		<PagerListLayout
			ref="pagerTable"
			class="w-100"
			:show-divider="false"
			:manu-items="menuItems"
			item-classes="card p-3 mb-2"
			:pager-provider="dataPagerProvider"
			:analytics-props="analyticsPropsMethod()">

			<template #item-title="{item, index}">
				<div class="">
<!--					<div>{{item.title }}</div>-->
					<div>Invoice for: {{ item.targetObjectTitle }}</div>
					<div>Invoice to: {{ item.billTo.name }}</div>
					<div>Amount: paid {{ item.getAmountPaidFormatted() }} out of {{ item.getTotalAmountFormatted() }}</div>

					<!--					<ClientRow v-for="(clientProfile, index) in dataArray" :key="index"-->
					<!--							   :client-profile="clientProfile"-->
					<!--							   :hide-divider="index === dataArray.length - 1"-->
					<!--							   class="w-100 cursor-pointer hover px-3"-->
					<!--							   @change="updateClientProfile(clientProfile)"-->
					<!--							   @click.native="onClientClicked(clientProfile)"/>-->
				</div>


			</template>

			<template #empty-view>

				<qw-empty>
					<template #title>
						All invoices will show up here.
					</template>
				</qw-empty>
			</template>

		</PagerListLayout>
	</div>
</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import PagerListLayout from "@/core/components/PagerListLayout.vue";
import BaseDataFilter from "@/core/js/backend/filters/BaseDataFilter";

export default {
	extends: BaseComponent,
	name: "InvoiceListPage",

	components: {
		PagerListLayout,
	},
	data() {
		return {
			menuItems: []
		}
	},
	created() {

	},
	methods: {
		async dataPagerProvider() {
			let dataFilter = new BaseDataFilter()
			dataFilter
				.setLimit(10)
				.orderByDesc("createdAt")
			return this.$dataManager.getInvoiceItemListPager(dataFilter)
		},
	},

}
</script>

<style>

</style>
